import amplitude from 'amplitude-js'

import type { AmplitudeAgentInfo } from '@brighterly/lib-core-types/tools/amplitude/interfaces'

import { pick } from '@helpers/object'
import { isString } from '@helpers/string'

import { getDeviceType } from './device'

const scan = (val: string | number | null): string | number | null => (isString(val) || typeof val === 'number') ? val : null

export const getUserAgentInfo = (): AmplitudeAgentInfo => {
  // @ts-expect-error isolated type _ua
  const info = amplitude.getInstance()._ua

  return pick({
    device_type: getDeviceType(),
    user_agent: scan(info.ua),
  })
}
